import RenovationRibbon from "@/components/RenovationRibbon";
import { useLanguage } from "@/contexts/LanguageContext";
import { getLocalizedUrl } from "@/utils/languageUtils";

const SpaRenovationRibbon = () => {
  const { language } = useLanguage();

  return (
    <RenovationRibbon
      translationBase="spa.renovationNotice"
      storageKey="spa-renovation-ribbon-dismissed-v2"
      dataOid="spa-renovation-ribbon"
      primaryHref={getLocalizedUrl("/book", language)}
    />
  );
};

export default SpaRenovationRibbon;
